export default {
	methods: {
		tvButtons: function () {
			return ar.tvButtons();
		},
	}
};
